// angular
//     .module("HeroPRO")
//     .controller("DocumentPreviewController", documentPreviewController);

import './documentPreview.scss';

/* @ngInject */
export default function documentPreviewController($scope) {
    $scope.pdfUrl = '';

    $scope.$on('HPFileUploaded', (event, data, file) => {
        const uploadedFile = file;
        $scope.$apply(() => {
            $scope.pdfUrl = uploadedFile.downloadUrl;
        });
    });
}



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/uploadDocumentsModal/documentPreviewController.js